// import React from "react";
// import "./CSS/FounderSection.css";
// import founderImg from "./IMAGES/Component 31.png";

// const FounderSection = () => {
//   return (
//     <div className="founder-container">
//       <div className="founder-card">
//          <span className="corner-top-right"></span>
//   <span className="corner-bottom-left"></span>
//         <div className="founder-image">
//           <img src={founderImg} alt="Founder" />
//         </div>

//         <div className="founder-content">
//           <p className="quote">
//            At Sapra – we personally believe fashion is not just about clothes.
// It is about expressing who you are, refined elegance, and style. I am deeply passionate about staying ahead of the latest trends, and I want all my royal customers to carry themselves with that same level of confidence.
//           </p>

//           <p className="author">
//             Prachi Kunjir - Founder & CEO, SaPra House of Élan
//           </p>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default FounderSection;

import React, { useState, useEffect } from "react";
import "./CSS/FounderSection.css";
import founderImg from "./IMAGES/Component 31.png";

const API_URL = "https://api.sapra.co.in/api/Upload/admin-image";

const FounderSection = () => {
  const [imageUrl, setImageUrl] = useState(founderImg);

  useEffect(() => {
    const fetchFounderImage = async () => {
      try {
        const response = await fetch(API_URL);

        if (!response.ok) {
          throw new Error("Image API failed");
        }

        const data = await response.json();

        if (data?.imageUrl) {
          const secureUrl = data.imageUrl.replace(/^http:\/\//i, "https://");

          setImageUrl(secureUrl);
        }
      } catch (error) {
        console.error("Founder image error:", error);
        setImageUrl(founderImg);
      }
    };

    fetchFounderImage();
  }, []);

  return (
    <div className="founder-container">
      <div className="founder-card">
        <span className="corner-top-right"></span>
        <span className="corner-bottom-left"></span>

        <div className="founder-image">
          <img
            src={imageUrl}
            alt="Prachi Kunjir - Founder"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = founderImg;
            }}
          />
        </div>

        <div className="founder-content">
          <p className="quote">
            At Sapra – we personally believe fashion is not just about clothes.
            It is about expressing who you are, refined elegance, and style. I
            am deeply passionate about staying ahead of the latest trends, and I
            want all my royal customers to carry themselves with that same level
            of confidence.
          </p>

          <p className="author">
            Prachi Kunjir - Founder & CEO, SaPra House of Élan
          </p>
        </div>
      </div>
    </div>
  );
};

export default FounderSection;
